import { render, staticRenderFns } from "./SingularityEmptyState.vue?vue&type=template&id=31dfc89d&scoped=true&"
import script from "./SingularityEmptyState.vue?vue&type=script&lang=ts&"
export * from "./SingularityEmptyState.vue?vue&type=script&lang=ts&"
import style0 from "./SingularityEmptyState.vue?vue&type=style&index=0&id=31dfc89d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dfc89d",
  null
  
)

export default component.exports